import * as React from 'react';

export const JOB_STALLED_AFTER_MS = 5 * 60 * 1000;

export function useJobStallTimeout({
	enabled,
	fingerprint,
	onStalled,
	stallAfterMs = JOB_STALLED_AFTER_MS,
}: {
	enabled: boolean;
	fingerprint: string;
	onStalled: () => void;
	stallAfterMs?: number;
}) {
	const onStalledRef = React.useRef(onStalled);
	React.useEffect(() => {
		onStalledRef.current = onStalled;
	});

	React.useEffect(() => {
		if (!enabled) {
			return;
		}
		const timer = setTimeout(() => onStalledRef.current(), stallAfterMs);
		return () => clearTimeout(timer);
	}, [enabled, fingerprint, stallAfterMs]);
}
